import React from 'react';
import { Space } from 'antd';

const AppStoreLinks = () => {
    return (
        <Space size="middle" style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
            <a href="https://link.vitalstaf.com/ios" target="_blank" rel="noopener noreferrer">
                <img 
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" 
                    alt="Download on the App Store" 
                    style={{ height: 40 }} 
                />
            </a>
            <a href="https://link.vitalstaf.com/android" target="_blank" rel="noopener noreferrer">
                <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                    alt="Get it on Google Play" 
                    style={{ height: 40 }} 
                />
            </a>
        </Space>
    );
};

export default AppStoreLinks;
